import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { IShipmentApiResponse, LogisticsActionKeys, UpdateShipment, UpdateShipmentRequest } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* updateShipmentSaga(action: UpdateShipment) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateShipment, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setShipment(response.value));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateShipment() {
  yield takeEvery(LogisticsActionKeys.UPDATE_SHIPMENT, updateShipmentSaga);
}

export async function updateShipment(
  shipment: UpdateShipmentRequest
): Promise<IApiExecuteRespone<IShipmentApiResponse>> {
  return executeApiRequest(() => httpService.post(ApiUrls.shipment(shipment.shipmentId), shipment));
}
